import { render, staticRenderFns } from "./qs3-03.vue?vue&type=template&id=508aad2b&scoped=true&"
import script from "./qs3-03.vue?vue&type=script&lang=js&"
export * from "./qs3-03.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508aad2b",
  null
  
)

export default component.exports